import type { CallType } from "./call-type";
import { mountMeeting } from "./meeting";
import { renderError, renderLoading } from "./ui";

/**
 * Host flow: `https://<this-app>/room?authToken=<token>&callType=<video|audio>`.
 *
 * The hub app already minted this RealtimeKit participant auth token itself
 * (via its own authenticated `POST /api/meetings/:id/token`, which also
 * returns `callType` — backend-feathub#171) and embeds both in the link it
 * sends the host. This app makes no backend calls of its own for this flow —
 * it just initializes the RealtimeKit client directly.
 */
export async function startHostFlow(
  authToken: string,
  callType: CallType,
  container: HTMLElement,
): Promise<void> {
  renderLoading(container, "Conectando a la reunión...");

  try {
    await mountMeeting(authToken, callType, container);
  } catch {
    renderError(container);
  }
}
